export const API_ENDPOINTS = {
  wishlistGet: '/api/wishlist/getWishlists',
  wishlistAdd: '/api/wishlist/addWishlist',
  wishlistDelete: '/api/wishlist/deleteWishlist',
}
